import { CSSProperties, HTMLAttributes } from 'react';

import Flex from '../../../Flex';
import { HeaderCellProps } from '../../types';

import { ArrowIcon, Cell, CellFilter, CellLabel } from './styled';

type Props = HeaderCellProps & {
  className?: string;
  style?: CSSProperties;
  filter?: string | JSX.Element;
};

/**
 * Default implementation of header cell component
 */
const DefaultDataTableHeaderCell = (props: Props) => {
  const {
    sortDirection,
    sortKey,
    columnKey,
    label,
    isSortable,
    onSort,
    className,
    style,
    filter,
  } = props;

  const handleSort = () => {
    onSort(sortDirection === 'asc' ? 'desc' : 'asc');
  };

  const clickProps: HTMLAttributes<HTMLTableCellElement> = isSortable
    ? {
        role: 'button',
        tabIndex: 0,
        onClick: handleSort,
        onKeyDown: e => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleSort();
          }
        },
      }
    : {};

  const hasFilter = !!filter;

  return (
    <Cell
      $hasFilter={hasFilter}
      className={className}
      data-column={columnKey}
      style={style}
      {...clickProps}>
      <Flex direction="column">
        {hasFilter && <CellFilter>{filter}</CellFilter>}
        <Flex align="center">
          <CellLabel>{label}</CellLabel>
          {isSortable && (
            <ArrowIcon
              $direction={sortDirection}
              $isSorted={sortKey === columnKey}
            />
          )}
        </Flex>
      </Flex>
    </Cell>
  );
};

export default DefaultDataTableHeaderCell;
